import type { ComponentType } from 'react';
import { cn } from '@/components/ui';
import { MarketingPathIllustration } from './resolveMarketingIllustration';

export type MarketingHeroIllustrationProps = {
  /** Marketing path without locale, e.g. `services`, `ai-agents/conversational-ai`. */
  path: string;
  className?: string;
};

function normalizePath(path: string): string {
  return path.replace(/^\//, '').replace(/\/$/, '');
}

export function resolveMarketingHeroIllustrationComponent(
  path: string
): ComponentType<{ className?: string }> {
  const normalized = normalizePath(path);
  return function PathIllustration({ className }) {
    return <MarketingPathIllustration path={normalized} className={className} />;
  };
}

/** Theme-aware SVG hero art for all marketing hub, category, leaf, and special routes. */
export default function MarketingHeroIllustration({ path, className }: MarketingHeroIllustrationProps) {
  return (
    <MarketingPathIllustration
      path={normalizePath(path)}
      className={cn('marketing-hero-illustration', className)}
    />
  );
}
